<template>
    <div id="mapid"></div>
</template>

<script>

import "leaflet";
import "leaflet-fullscreen";
import "leaflet.markercluster";

import MapPopup from "./MapPopup";
import ukJSON from "../assets/json/ukraine.geo.json";
import Vue from "vue";
import AirService from "../services/AirService";
import BotsService from "@/services/BotsService";
import EventBus from "./EventBus";
import _ from "underscore"

export default {
    name: "Map",
    components: {
        MapPopup
    },
    props: [
        "initialLon",
        "initialLat",
        "initialZoom",
        "countryBorder",
        "localityButton"
    ],
    data() {
        return {
            devices: [],
            botDevices: [],
            map: null,
            currentDevice: null
        }
    },
    methods: {
        renderMap() {
            let markers = L.markerClusterGroup();

            this.map = L.map('mapid', {
                fullscreenControl: true,
            }).setView([this.initialLon || 48.521185, this.initialLat || 31.126392], this.initialZoom || 6);

            L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
                maxZoom: 18,
                attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
                    '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                    'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                id: 'mapbox/streets-v11',
                tileSize: 512,
                zoomOffset: -1,
            }).addTo(this.map);

            let settings = {
                fillColor: "#00c5ff",
                color: "#005efd",
                opacity: 1,
                fillOpacity: 0.2
            }

            if (this.countryBorder !== false) {
                L.geoJSON(ukJSON, settings).addTo(this.map);
            }

            let self = this;

            this.devices.forEach(device => {
                if (device.tags) {
                    let marker = L.marker([device.tags.latitude, device.tags.longitude]).on("click", function () {
                        let botDevice = _.findWhere(self.botDevices, {devEUI: device.devEUI})
                        self.onMarkerClick(device, botDevice, this)
                    });
                    markers.addLayer(marker);
                }
            });

            this.map.addLayer(markers);

            this.map.on('popupopen', (e) => {
                var px = this.map.project(e.popup._latlng);
                px.y -= 270;
                this.map.panTo(this.map.unproject(px), {animate: true});
            });
        },
        onMarkerClick(device, botDevice, marker) {
            if (window.innerWidth < 600) {
                EventBus.$emit("MARKER_ONCLICK", {
                    device, marker, botDevice
                });

                return;
            }

            let MapPopupClass = Vue.extend(MapPopup);
            let instance = new MapPopupClass({
                propsData: {
                    device: device,
                    botDevice: botDevice,
                    router: this.$router,
                    localityButton: this.localityButton
                }
            });

            instance.$mount()

            this.currentDevice = device;

            let popup = L.popup({
                className: "osm-popup",
                maxHeight: 600,
                offset: [0, -10]
            })
                .setLatLng(marker.getLatLng())
                .setContent(instance.$el)
                .openOn(this.map);
            popup.openPopup();
        },
    },
    async mounted() {
        // https://github.com/vue-leaflet/Vue2Leaflet/issues/103
        delete L.Icon.Default.prototype._getIconUrl
        L.Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png')
        })

        this.devices = await (new AirService()).fetchDevices();
        this.botDevices = await (new BotsService()).fetchDevices();
        this.renderMap();
        this.$emit("ready");
    }
}
</script>

<style lang="less" scoped>

@import "../../node_modules/leaflet/dist/leaflet.css";
@import "../../node_modules/leaflet-fullscreen/dist/leaflet.fullscreen.css";
@import "../../node_modules/leaflet.markercluster/dist/MarkerCluster.css";
@import "../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css";


</style>